import React from 'react';

import {
  IonButtons,
  IonIcon,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from '@ionic/react';

import { useUser } from 'auth/User';
import Impersonate from 'components/Impersonate';

const TopToolbar = ({ title, children }: any) => {
  const { isDevUser } = useUser();
  return (
    <>
      <IonToolbar data-cy={'TopToolbar'}>
        <IonButtons slot={'start'}>
          <IonMenuButton data-cy={'MenuButton'}></IonMenuButton>
          {isDevUser ? <IonIcon /> : null}
        </IonButtons>
        <IonTitle>{title}</IonTitle>
        <IonButtons slot={'end'}>{children}</IonButtons>
      </IonToolbar>
      <div className={'flex'}>
        <Impersonate className={'radius-none full-width'} />
      </div>
    </>
  );
};

export default TopToolbar;
